import { useQuery, UseQueryOptions } from 'react-query';

import { User } from './userEntity';
import { GetUserDataByTokenError, getUserDataByToken } from './userService';

function useGetUser<TData = Array<User>>(
  options?: UseQueryOptions<
    Array<User>,
    GetUserDataByTokenError,
    TData,
    'user-profile'
  >,
) {
  return useQuery('user-profile', () => getUserDataByToken(), options);
}

export { useGetUser };
